

// function on change gift product varinat 
function onChangeVariantGift() {
  var gift_box = document.querySelector(".gift_product_content");
  if (gift_box != null || gift_box != undefined) {
    var wish_list_variants = gift_box.querySelector(".wish_list_variants")
    if (wish_list_variants != null || wish_list_variants != undefined) {
      var selectedOptionVariantId = wish_list_variants.querySelector(`[value='${wish_list_variants.value}']`).getAttribute("variantid");
      var addToCartClosestBtn = wish_list_variants.closest(".gift_product_content").querySelector('[data-id]')
      addToCartClosestBtn.setAttribute("data-id", `${selectedOptionVariantId}`);
    }
  }
};


// function add gift to cart 
function atcGift() {
  var atc_btn = document.querySelector(".atc_btn");
  const selectElement = document.querySelector('.gift_box select');
  const selectedOption = selectElement?.options[selectElement?.options?.selectedIndex]?.getAttribute('data-variant-id');

  if (!atc_btn || !selectedOption) return;
  
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: +selectedOption
    },
    dataType: 'json',
    success: function () {
      document.dispatchEvent(new CustomEvent('cart:open'));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: +selectedOption
        }
      }));
      //console.log("done");
    }
    ,
    error: function () {
      //console.log("error");
    }
  })
};

// add atc function to items buttons 
setTimeout(() => {
  var atcButtons = document.querySelectorAll('.featured-collection__form .add-to-cart');
  if (atcButtons && atcButtons.length > 0) {
    document.querySelectorAll('.featured-collection__form .add-to-cart').forEach(function (button) {
      button.addEventListener('click', function (e) {
        const selectElement = e.target.closest('.featured-collection__form').querySelector('.featured-product__variants');
        const selectedOption = selectElement.selectedOptions[0];
        const variantId = selectedOption.getAttribute("data-variant-id");

        const productPriceElements = document.querySelectorAll('[data-product-price]');
        // Loop through each element and update its data-product-id attribute
        productPriceElements.forEach(element => {
          if (element.hasAttribute('data-variant-id')) {
            element.setAttribute('data-variant-id', variantId);
          } else {
            console.warn('Element has data-product-price but lacks data-variant-id');
          }
        });

        if (!!variantId) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ quantity: 1, id: variantId })
          })
            .then(function (response) {
              if (response.ok) {
                document.dispatchEvent(new CustomEvent('cart:open'));
                document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
              }
            })
            .catch(function (error) {
              console.log("error", error);
            });
        }
      });
    });
  }

  function adjustCardHeights() {
    let cards = document.querySelectorAll('.grid-product__content');
    let maxHeight = 0;
    if (cards && cards.length > 0) {
    cards.forEach(function(card) {
      card.style.height = 'auto';
    });
    
    cards.forEach(function(card) {
      let cardHeight = card.offsetHeight;
      maxHeight = Math.max(maxHeight, cardHeight);
    });
    
    cards.forEach(function(card) {
      card.style.height = maxHeight + 'px';
    });
  }
  }
  adjustCardHeights()
  window.addEventListener('resize', adjustCardHeights);
}, "1500");